/**
 * @generated SignedSource<<70a28958ae7c6e886b6dbf9449df7d68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentRoadmapProgressByGradeFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  standardStateId: string;
  targetGroupId: string;
};
export type ProgressStudentsRoadmapByGradeQuery$variables = {
  filter: StudentRoadmapProgressByGradeFilterInput;
};
export type ProgressStudentsRoadmapByGradeQuery$data = {
  readonly studentRoadmapProgressByGrade: ReadonlyArray<{
    readonly currentRoadmapId: number | null | undefined;
    readonly currentRoadmapName: string | null | undefined;
    readonly gradeSummaries: ReadonlyArray<{
      readonly demonstrated: number;
      readonly gradeName: string;
      readonly total: number;
    }>;
    readonly studentFirstName: string;
    readonly studentId: number;
    readonly studentLastName: string;
    readonly studentPublicUserId: string;
  }>;
};
export type ProgressStudentsRoadmapByGradeQuery = {
  response: ProgressStudentsRoadmapByGradeQuery$data;
  variables: ProgressStudentsRoadmapByGradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentRoadmapProgress",
    "kind": "LinkedField",
    "name": "studentRoadmapProgressByGrade",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentRoadmapId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentRoadmapName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GradeSummary",
        "kind": "LinkedField",
        "name": "gradeSummaries",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gradeName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "demonstrated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "studentLastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "studentFirstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "studentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "studentPublicUserId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProgressStudentsRoadmapByGradeQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProgressStudentsRoadmapByGradeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e15ab37199e176e67bbea2c39a66a7a",
    "id": null,
    "metadata": {},
    "name": "ProgressStudentsRoadmapByGradeQuery",
    "operationKind": "query",
    "text": "query ProgressStudentsRoadmapByGradeQuery(\n  $filter: StudentRoadmapProgressByGradeFilterInput!\n) {\n  studentRoadmapProgressByGrade(filter: $filter) {\n    currentRoadmapId\n    currentRoadmapName\n    gradeSummaries {\n      gradeName\n      demonstrated\n      total\n    }\n    studentLastName\n    studentFirstName\n    studentId\n    studentPublicUserId\n  }\n}\n"
  }
};
})();

(node as any).hash = "241c558b6f4c6a458d2ebe3b1bea4c9e";

export default node;
